<template>
  <div>
    <v-form>
      <v-layout justify-space-between column>
        <v-flex xs12 sm12 md12 pa-1>
          <v-card class="white--text">
            <v-card   flat="">
              <v-card-actions>
                <v-layout row="" wrap="">
                  <v-flex xs12 sm4 md3>
                    <parainput :etiket="'Toplam Tutar'" :aktif="'false'" v-model="val.TutarBilgileri.NetTutar.NetTutar"
                      :autocomplete="'autocomplete'"></parainput>
                  </v-flex>
                  <v-flex xs12 sm4 md3>
                    <doviztutarcomp :etiket="'Toplam Satış Döviz'" :aktif="'false'" v-model="val.TutarBilgileri.NetTutar.NetTutarSatisDoviz"
                      :autocomplete="'autocomplete'"></doviztutarcomp>
                  </v-flex>
                  <v-flex xs12 sm4 md3>
                    <doviztutarcomp :etiket="'Toplam Alış Döviz'" :aktif="'false'" v-model="val.TutarBilgileri.NetTutar.NetTutarAlisDoviz"
                      :autocomplete="'autocomplete'"></doviztutarcomp>
                  </v-flex>

                </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>


        <v-flex xs12 sm12 md12 pa-1>
          <v-card class="white--text">
            <v-card   flat="">
              <v-card-actions>

                <v-layout row="" wrap="">
                  <v-flex xs12 sm4 md3>
                    <v-select hide-details="" @change="kurgetir(kur)" :items="doviztipi" v-model="kur" clearable
                      item-text="DovizUnvan" item-value="DovizKod" label="Döviz Tipi"></v-select>
                  </v-flex>
                  <v-flex xs12 sm4 md3>
                    <dovizinput v-model="kurdegeri" :etiket="'Kur Tutarı'"> </dovizinput>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>


        <v-flex xs12 sm12 md12 pa-1>
          <v-card class="white--text">
            <v-card   flat="">
              <v-card-actions>
                <v-layout row wrap>
                  <v-flex xs12 sm4 md3>
                    <parainput :etiket="'Bilet Tutarı'" v-model="val.TutarBilgileri.Tutar.Tutar" :autocomplete="'autocomplete'"></parainput>
                  </v-flex>
                  <v-flex xs12 sm4 md3>
                    <doviztutarcomp :etiket="'Döviz Satış'" v-model="val.TutarBilgileri.Tutar.TutarSatisDoviz"
                      :autocomplete="'autocomplete'"></doviztutarcomp>
                  </v-flex>
                  <v-flex xs12 sm4 md3>
                    <doviztutarcomp :etiket="'Döviz Alış'" v-model="val.TutarBilgileri.Tutar.TutarAlisDoviz"
                      :autocomplete="'autocomplete'"></doviztutarcomp>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>

        <v-flex xs12 sm12 md12 pa-1>
          <v-card class="white--text">
            <v-card   flat="">
              <v-card-actions>

                <v-layout row wrap>
                  <v-flex xs12 sm4 md3>
                    <parainput :etiket="'MCO/PTA'" v-model="val.TutarBilgileri.PtaTutar.PtaTutar" :autocomplete="'autocomplete'"></parainput>
                  </v-flex>
                  <v-flex xs12 sm4 md3>
                    <doviztutarcomp :etiket="'Döviz Satış'" v-model="val.TutarBilgileri.PtaTutar.PtaSatisDoviz"
                      :autocomplete="'autocomplete'"></doviztutarcomp>
                  </v-flex>
                  <v-flex xs12 sm4 md3>
                    <doviztutarcomp :etiket="'Döviz Alış'" v-model="val.TutarBilgileri.PtaTutar.PtaAlisDoviz"
                      :autocomplete="'autocomplete'"></doviztutarcomp>
                  </v-flex>
                </v-layout>

              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>

        <v-flex xs12 sm12 md12 pa-1>
          <v-card class="white--text">
            <v-card   flat="">
              <v-card-actions>

                <v-layout v-if="ichatmi" wrap row>
                  <v-flex xs12 sm4 md3>
                    <parainput :etiket="'Alan Vergisi'" v-model="val.TutarBilgileri.AlanVergiTutar.AlanVergiTutar"
                      :autocomplete="'autocomplete'"></parainput>
                  </v-flex>
                  <v-flex xs12 sm4 md3>
                    <doviztutarcomp :etiket="'Döviz Satış'" v-model="val.TutarBilgileri.AlanVergiTutar.AlanVergiSatisDoviz"
                      :autocomplete="'autocomplete'"></doviztutarcomp>
                  </v-flex>
                  <v-flex xs12 sm4 md3>
                    <doviztutarcomp :etiket="'Döviz Alış'" v-model="val.TutarBilgileri.AlanVergiTutar.AlanVergiAlisDoviz"
                      :autocomplete="'autocomplete'"></doviztutarcomp>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>

        <v-flex v-if="dishatmi" xs12 sm12 md12 pa-1>
          <v-card class="white--text">
            <v-card   flat="">
              <v-card-actions>

                <v-layout row="" wrap>
                  <v-flex xs12 sm4 md3>
                    <parainput :etiket="'Tax Vergisi'" v-model="val.TutarBilgileri.TaxTutar.TaxTutar" :autocomplete="'autocomplete'"></parainput>
                  </v-flex>
                  <v-flex xs12 sm4 md3>
                    <doviztutarcomp :etiket="'Döviz Satış'" v-model="val.TutarBilgileri.TaxTutar.TaxSatisDoviz"
                      :autocomplete="'autocomplete'"></doviztutarcomp>
                  </v-flex>
                  <v-flex xs12 sm4 md3>
                    <doviztutarcomp :etiket="'Döviz Alış'" v-model="val.TutarBilgileri.TaxTutar.TaxAlisDoviz"
                      :autocomplete="'autocomplete'"></doviztutarcomp>
                  </v-flex>

                </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>

        <v-flex v-if="ichatmi" xs12 sm12 md12 pa-1>
          <v-card class="white--text">
            <v-card   flat="">
              <v-card-actions>

                <v-layout row wrap="">
                  <v-flex xs12 sm4 md3>
                    <parainput :etiket="'Y.F.F.'" v-model="val.TutarBilgileri.YFFTutar.YFFTutar" :autocomplete="'autocomplete'"></parainput>
                  </v-flex>
                  <v-flex xs12 sm4 md3>
                    <doviztutarcomp :etiket="'Döviz Satış'" v-model="val.TutarBilgileri.YFFTutar.YFFDoviz"
                      :autocomplete="'autocomplete'"></doviztutarcomp>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>



        <v-flex xs12 sm12 md12 pa-1>
          <v-card class="white--text">
            <v-card   flat="">
              <v-card-actions>
                <v-layout row="" wrap="">
                  <v-flex xs12 sm4 md3>
                    <parainput :etiket="'Diğer Servis'" v-model="val.TutarBilgileri.DigerServisTutar.DigerServisTutar"
                      :autocomplete="'autocomplete'"></parainput>
                  </v-flex>
                  <v-flex xs12 sm4 md3>
                    <doviztutarcomp :etiket="'Döviz Satış'" v-model="val.TutarBilgileri.DigerServisTutar.DigerServisDoviz"
                      :autocomplete="'autocomplete'"></doviztutarcomp>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>

        <v-flex xs12 sm12 md12 pa-1>
          <v-card class="white--text">
            <v-card   flat="">
              <v-card-actions>
                <v-layout row="" wrap="">
                  <v-flex xs12 sm4 md3>
                    <parainput :etiket="'Ceza'" v-model="val.TutarBilgileri.CezaTutar.CezaTutar" :autocomplete="'autocomplete'"></parainput>
                  </v-flex>
                  <v-flex xs12 sm4 md3>
                    <doviztutarcomp :etiket="'Döviz Satış'" v-model="val.TutarBilgileri.CezaTutar.CezaSatisTutar"
                      :autocomplete="'autocomplete'"></doviztutarcomp>
                  </v-flex>
                  <v-flex xs12 sm4 md3>
                    <doviztutarcomp :etiket="'Döviz Alış'" v-model="val.TutarBilgileri.CezaTutar.CezaAlisTutar"
                      :autocomplete="'autocomplete'"></doviztutarcomp>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>

        <v-flex xs12 sm12 md12 pa-1>
          <v-card class="white--text">
            <v-card   flat="">
              <v-card-actions>
                <v-layout row="" wrap="">
                  <v-flex xs12 sm4 md3>
                    <parainput :etiket="'Servis'" v-model="val.TutarBilgileri.ServisTutar.ServisTutar" :autocomplete="'autocomplete'"></parainput>
                  </v-flex>
                  <v-flex xs12 sm4 md3>
                    <doviztutarcomp :etiket="'Döviz Satış'" v-model="val.TutarBilgileri.ServisTutar.ServisDoviz"
                      :autocomplete="'autocomplete'"></doviztutarcomp>
                  </v-flex>
                  <v-flex xs12 sm4 md3>
                    <v-select hide-details="" v-model="val.TanimBilgileri.ServisKod" :items="efaturatipi" clearable
                      item-text="text" item-value="value" label="Servis Tipi"></v-select>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>
        <v-flex xs12 sm12 md12 pa-1>
          <v-card class="white--text">
            <v-card   flat="">
              <v-card-actions>
                <v-layout row="" wrap="">
                  <v-flex xs12 sm4 md3>
                    <parainput :etiket="'Rez. Tutarı'" v-model="val.TutarBilgileri.ReserveTutar.ReserveTutar"
                      :autocomplete="'autocomplete'"></parainput>
                  </v-flex>
                  <v-flex xs12 sm4 md3>
                    <doviztutarcomp :etiket="'Döviz Satış'" v-model="val.TutarBilgileri.ReserveTutar.ReserveDoviz"
                      :autocomplete="'autocomplete'"></doviztutarcomp>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>
        <v-flex xs12 sm12 md12 pa-1>
          <v-card class="white--text">
            <v-card   flat="">
              <v-card-actions>
                <v-layout row="" wrap="">
                  <v-flex xs12 sm4 md3>
                    <parainput :etiket="'İskonto'" v-model="val.TutarBilgileri.IskontoTutar.IskontoTutar" :autocomplete="'autocomplete'"></parainput>
                  </v-flex>
                  <v-flex xs12 sm4 md3>
                    <doviztutarcomp :etiket="'Döviz Satış'" v-model="val.TutarBilgileri.IskontoTutar.IskontoDoviz"
                      :autocomplete="'autocomplete'"></doviztutarcomp>
                  </v-flex>
                  <v-flex xs12 sm4 md3>
                    <yuzdeinput :etiket="'İskonto %'" v-model="val.TutarBilgileri.IskontoTutar.IskontoYuzde"
                      :autocomplete="'autocomplete'"></yuzdeinput>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>

        <v-flex xs12 sm12 md12 pa-1>
          <v-card class="white--text">
            <v-card   flat="">
              <v-card-actions>
                <v-layout row="" wrap="">
                  <v-flex xs12 sm4 md3>
                    <parainput :etiket="'Charter PTA'" v-model="val.TutarBilgileri.CharterTutar.CharterTutar"
                      :autocomplete="'autocomplete'"></parainput>
                  </v-flex>
                  <v-flex xs12 sm4 md3>
                    <doviztutarcomp :etiket="'Döviz Satış'" v-model="val.TutarBilgileri.CharterTutar.CharterSatisDoviz"
                      :autocomplete="'autocomplete'"></doviztutarcomp>
                  </v-flex>
                  <v-flex xs12 sm4 md3>
                    <doviztutarcomp :etiket="'Döviz Alış'" v-model="val.TutarBilgileri.CharterTutar.CharterAlisDoviz"
                      :autocomplete="'autocomplete'"></doviztutarcomp>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>

        <v-flex xs12 sm12 md12 pa-1>
          <v-card class="white--text">
            <v-card   flat="">
              <v-card-actions>
        <v-layout row="" wrap="">
          <v-flex xs12 sm4 md3>
            <parainput :etiket="'KA Vergisi'" v-model="val.TutarBilgileri.KaTutar.KaTutar" :autocomplete="'autocomplete'"></parainput>
          </v-flex>
          <v-flex xs12 sm4 md3>
            <doviztutarcomp :etiket="'Döviz Satış'" v-model="val.TutarBilgileri.KaTutar.KaDoviz" :autocomplete="'autocomplete'"></doviztutarcomp>
          </v-flex>
        </v-layout>
             </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>

<v-flex xs12 sm12 md12 pa-1>
          <v-card class="white--text">
            <v-card   flat="">
              <v-card-actions>
        <v-layout row="" wrap="">
          <v-flex xs12 sm4 md3>
            <parainput :etiket="'Gross'" v-model="val.DigerBilgileri.GrossTutar" :autocomplete="'autocomplete'"></parainput>
          </v-flex>
        </v-layout>
             </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>

<v-flex xs12 sm12 md12 pa-1>
          <v-card class="white--text">
            <v-card   flat="">
              <v-card-actions>
        <v-layout row="" wrap="">
          <v-flex xs12 sm4 md3>
            <parainput :etiket="'Alış Servis'" v-model="val.OdemeBilgileri.AlisServisTutar.AlisServisTutar"
              :autocomplete="'autocomplete'"></parainput>
          </v-flex>
          <v-flex xs12 sm4 md3>
            <doviztutarcomp :etiket="'Döviz Alış'" v-model="val.OdemeBilgileri.AlisServisTutar.AlisServisDoviz"
              :autocomplete="'autocomplete'"></doviztutarcomp>
          </v-flex>

        </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>



<v-flex xs12 sm12 md12 pa-1>
          <v-card class="white--text">
            <v-card   flat="">
              <v-card-actions>
        <v-layout row="" wrap="">


          <v-flex xs12 sm3 md3>
            <parainput :etiket="'Komisyon'" v-model="parainputdeger" :autocomplete="'autocomplete'"></parainput>
          </v-flex>
          <v-flex xs12 sm3 md3>
            <doviztutarcomp :etiket="'Döviz Satış'" v-model="parainputdeger" :autocomplete="'autocomplete'"></doviztutarcomp>
          </v-flex>
          <v-flex xs12 sm3 md3>
            <doviztutarcomp :etiket="'Döviz Alış'" v-model="parainputdeger" :autocomplete="'autocomplete'"></doviztutarcomp>
          </v-flex>
          <v-flex xs12 sm3 md3>
            <v-select hide-details="" :items="komisyontip" v-model="val.OdemeBilgileri.KomisyonTip" clearable item-text="text"
              item-value="value" label="Komisyon Tip"></v-select>
          </v-flex>
        </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>

<v-flex xs12 sm12 md12 pa-1>
          <v-card class="white--text">
            <v-card   flat="">
              <v-card-actions>
        <v-layout row="" wrap="">
          <v-flex xs12 sm4 md3>
            <parainput :etiket="'Analiz1'" v-model="val.TanimBilgileri.AnalizTutar" :autocomplete="'autocomplete'"></parainput>
          </v-flex>
          <v-flex xs12 sm4 md3>
            <analizcomp :etiket="'Analiz Kod'" v-model="val.TanimBilgileri.AnalizKod.AnalizKod"></analizcomp>

          </v-flex>
        </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>

<v-flex xs12 sm12 md12 pa-1>
          <v-card class="white--text">
            <v-card   flat="">
              <v-card-actions>
        <v-layout row="" wrap="">
          <v-flex xs12 sm4 md3>

            <parainput :etiket="'Analiz2'" v-model="val.TanimBilgileri.AnalizTutar1" :autocomplete="'autocomplete'"></parainput>
          </v-flex>
          <v-flex xs12 sm4 md3>
            <analizcomp :etiket="'Analiz Kod2'" v-model="val.TanimBilgileri.AnalizKod1.AnalizKod"></analizcomp>

          </v-flex>
        </v-layout>
                </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>

      </v-layout>




    </v-form>
  </div>
</template>

<script>
  import auth from '../../../../api/auth'
  import tarihcomp from '../../customcomp/tarihcomp'
  import parainput from '@/components/app/customcomp/parainput.vue'
  import dovizinput from '@/components/app/customcomp/dovizinput.vue'
  import yuzdeinput from '@/components/app/customcomp/yuzdeinput.vue'
  import doviztutarcomp from '@/components/app/customcomp/doviztutarcomp.vue'
  import analizcomp from "@/components/app/bilet/partpage/analizcomp.vue"



  export default {
    props: ["value", "ichatmi", "dishatmi"],
    beforeMount: beforeMount,
    components: {
      tarihcomp,
      parainput,
      dovizinput,
      yuzdeinput,
      doviztutarcomp,
      analizcomp

    },

    computed: {
      val: {
        get: function () {

          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },


    data() {
      return {
        doviztipi: [],
        kurdegeri: 0,
        kur: null,
        efaturatipi: '',
        parainputdeger: 0,
        komisyontip: [{
          text: 'K-Komisyonlu',
          value: 'K'
        }, {
          text: 'N-Komisyonsuz',
          value: 'N'
        }],
        efaturatipi: [{
            text: 'Ticari',
            value: '0'
          },
          {
            text: 'Temel',
            value: '1'
          },
          {
            text: 'İhracat',
            value: '2'
          }
        ],
      }
    },

    watch: {
      'kurdegeri': function (value1) {
        if (value1 != 0) {
          this.val.TutarBilgileri.Tutar.TutarSatisDoviz = this.val.TutarBilgileri.Tutar.Tutar / value1
          this.val.TutarBilgileri.PtaTutar.PtaSatisDoviz = this.val.TutarBilgileri.PtaTutar.PtaTutar / value1

          if (this.ichatmi == true) {
            this.val.TutarBilgileri.YFFTutar.YFFDoviz = this.val.TutarBilgileri.YFFTutar.YFFTutar / value1
            this.val.TutarBilgileri.AlanVergiTutar.AlanVergiSatisDoviz = this.val.TutarBilgileri.AlanVergiTutar.AlanVergiTutar /
              value1
          }

          if (this.dishatmi == true) {
            this.val.TutarBilgileri.TaxTutar.TaxSatisDoviz = this.val.TutarBilgileri.TaxTutar.TaxTutar / value1
          }

          this.val.TutarBilgileri.DigerServisTutar.DigerServisDoviz = this.val.TutarBilgileri.DigerServisTutar.DigerServisTutar /
            value1
          this.val.TutarBilgileri.CezaTutar.CezaSatisTutar = this.val.TutarBilgileri.CezaTutar.CezaTutar / value1
          this.val.TutarBilgileri.ServisTutar.ServisDoviz = this.val.TutarBilgileri.ServisTutar.ServisTutar /
            value1
          this.val.TutarBilgileri.ReserveTutar.ReserveDoviz = this.val.TutarBilgileri.ReserveTutar.ReserveTutar /
            value1
          this.val.TutarBilgileri.IskontoTutar.IskontoDoviz = this.val.TutarBilgileri.IskontoTutar.IskontoTutar /
            value1
          this.val.TutarBilgileri.CharterTutar.CharterSatisDoviz = this.val.TutarBilgileri.CharterTutar.CharterTutar /
            value1
          this.val.TutarBilgileri.KaTutar.KaDoviz = this.val.TutarBilgileri.KaTutar.KaTutar / value1
          this.val.OdemeBilgileri.AlisServisTutar.AlisServisDoviz = this.val.OdemeBilgileri.AlisServisTutar.AlisServisTutar /
            value1
        } else {
          value1 = 0
          this.val.TutarBilgileri.Tutar.TutarSatisDoviz = 0
          this.val.TutarBilgileri.PtaTutar.PtaSatisDoviz = 0

          if (this.ichatmi == true) {
            this.val.TutarBilgileri.YFFTutar.YFFDoviz = 0
            this.val.TutarBilgileri.AlanVergiTutar.AlanVergiSatisDoviz = 0
          }

          if (this.dishatmi == true) {
            this.val.TutarBilgileri.TaxTutar.TaxSatisDoviz = 0
          }

          this.val.TutarBilgileri.DigerServisTutar.DigerServisDoviz = 0
          this.val.TutarBilgileri.CezaTutar.CezaSatisTutar = 0
          this.val.TutarBilgileri.ServisTutar.ServisDoviz = 0
          this.val.TutarBilgileri.ReserveTutar.ReserveDoviz = 0
          this.val.TutarBilgileri.IskontoTutar.IskontoDoviz = 0
          this.val.TutarBilgileri.CharterTutar.CharterSatisDoviz = 0
          this.val.TutarBilgileri.KaTutar.KaDoviz = 0
          this.val.OdemeBilgileri.AlisServisTutar.AlisServisDoviz = 0
        }
      }
    },
    methods: {
      getDateNow: getDateNow,
      kurgetir(kod) {
        var params1 = {
          Tarih: this.val.TarihBilgileri.SatisTarihi,
          DovizKod: kod
        }
        this.$http.post(auth.API_URL + 'api/Helpers/GetRate', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.kurdegeri = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-Kur Hesapla'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-Kur Hesapla'
            this.snackbar = true
          }
        })
      },
    },
  }

  function getDateNow() {

    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }

    today = yyyy + '-' + mm + '-' + dd + 'T00:00:00'
    return today
  }

  function beforeMount() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params1 = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/currency/List', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.doviztipi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      }
    })
  }
</script>